import * as constants from './../constants';
import { autoCloseInSeconds } from '../actions/auto-close-in-seconds';
import { commonFlow } from './common-flow';
import { store } from '../../../store/store';
import { setStepName } from '../actions';
export const patientFlow = {
    ...commonFlow,
    [constants.TroubleshootingStepName.VideoRefreshed]: {
        textItems: [
            { text: 'troubleshooting.wizard.refreshVideoResultsDescription' },
        ],
        actions: {
            primary: {
                text: 'troubleshooting.wizard.yesButton',
                onClick: async () => {
                    store.dispatch(setStepName(constants.TroubleshootingStepName.ProblemResolved));
                    store.dispatch(autoCloseInSeconds(constants.DELAY_ON_RESOLVED));
                },
            },
            secondary: {
                text: 'troubleshooting.wizard.noButton',
                onClick: async () => {
                    store.dispatch(setStepName(constants.TroubleshootingStepName.NothingHelped));
                    store.dispatch(autoCloseInSeconds(constants.DELAY_ON_NOT_RESOLVED));
                },
            },
        },
    },
};
